import React from 'react';
import AsyncSelect from 'react-select/async';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@lomarengas/design-system';
import { useAppDispatch } from '../../../app/hooks';
import {
  AccommodationAutoCompleteOption,
  getAccommodationAutoCompleteOptionsAsync,
} from '../../../features/accommodations/accommodationsSlice';

export interface AccommodationOptionType {
  value: string;
  label: string;
}

interface CabinQuickSearchFieldOnlyProps {
  Placeholder?: string;
  parentHandleSelectAccommodationChange: (
    selectedAccommodation: AccommodationOptionType | null,
  ) => void;
  selectedAccommodation?: AccommodationOptionType | null;
}

const CabinQuickSearchFieldOnly = ({
  Placeholder = 'Hae kohteen numerolla tai nimellä...',
  parentHandleSelectAccommodationChange,
  selectedAccommodation,
}: CabinQuickSearchFieldOnlyProps) => {
  const dispatch = useAppDispatch();

  const handleSelectAccommodationChange = (
    selectedOption: AccommodationOptionType,
  ) => {
    if (selectedOption && selectedOption.label && selectedOption.value) {
      const accommodationUrlName = encodeURI(selectedOption.label);
      const accommodationId = selectedOption.value;
      if (parentHandleSelectAccommodationChange !== undefined) {
        parentHandleSelectAccommodationChange(selectedOption);
      }
    } else if (parentHandleSelectAccommodationChange !== undefined) {
      parentHandleSelectAccommodationChange(null);
    }
  };

  // Transform fetched options to match react-select format
  const formatOptions = (
    options: AccommodationAutoCompleteOption[] | undefined,
  ): AccommodationOptionType[] => {
    if (!options || options.length === 0) {
      return [];
    }

    const newOptions = options.map(option => ({
      value: option.accommodationId,
      label: `${option.accommodationNumber} - ${option.name}`,
    }));
    return newOptions;
  };

  const loadOptions = async (
    inputValue: string,
  ): Promise<AccommodationOptionType[]> => {
    try {
      const response = await dispatch(
        getAccommodationAutoCompleteOptionsAsync(inputValue),
      );
      // Access response data and format the options
      return formatOptions(response.payload.data);
    } catch (error) {
      console.error('Error fetching options:', error);
      return [];
    }
  };

  return (
    <AsyncSelect
      styles={{
        control: baseStyles => ({
          ...baseStyles,
          borderColor: '#ced4da',
          borderRadius: 6,
        }),
        dropdownIndicator: baseStyles => ({
          ...baseStyles,
          visibility: 'hidden',
        }),
        indicatorSeparator: baseStyles => ({
          ...baseStyles,
          visibility: 'hidden',
        }),
      }}
      classNames={{
        control: state => 'form-control form-control-search ps-48 pe-8',
      }}
      inputId="accommodationId"
      name="accommodationId"
      placeholder={Placeholder}
      isClearable
      isSearchable
      loadOptions={loadOptions}
      cacheOptions
      onChange={option => handleSelectAccommodationChange(option)}
      value={selectedAccommodation ?? null}
    />
  );
};

export default CabinQuickSearchFieldOnly;
export { CabinQuickSearchFieldOnly };
export type { CabinQuickSearchFieldOnlyProps };
